import React, { useImperativeHandle, useEffect, useState } from 'react';
import { Alert, Transfer, Spin } from 'antd';
import useTags from '../../gql/hooks/useTags';
import './styles.less';

const FormTags = ( { form, modifiedCallback, ref } ) => {
    const [ selectedTags, setSelectedTags ] = useState( [] );
    const { tags, tagsLoading, tagsError } = useTags();
    
    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { tagIdsAreModified: false } ); 
            form.setFieldsValue( { tagIdsModified: [] } ); 
            setSelectedTags( form.getFieldValue( 'tagIds' ) );
            modifiedCallback( false ); 
        }
    } ) );
     
    useEffect( () => tags && setSelectedTags( form.getFieldValue( 'tagIds' ) ), 
        [ tags, setSelectedTags ] );

    const handleTagsChange = ( values ) => {
        setSelectedTags( values ); 
    
        // check is modifed 
        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'tagIds' ) ) ) {
            form.setFieldsValue( { tagIdsAreModified: true } ); 
            form.setFieldsValue( { tagIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { tagIdsAreModified: false } ); 
            form.setFieldsValue( { tagIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-tags">
            
            { tagsLoading && 
                <Spin />
            }
            
            { tagsError && 
                <Alert 
                    type="error"
                    message="Error"
                    description="An unknown error occurred. Please try again later."
                />
            }

            { !tagsLoading && !tagsError &&
                <>
                    <h4>Tags</h4>

                    <Transfer
                        dataSource={ tags }
                        targetKeys={ selectedTags }
                        showSearch
                        titles={ [ 'Available', 'Selected' ] }
                        onChange={ handleTagsChange }
                        render={ i => {
                            if ( i.name ) {
                                return  i.name.length > 30 ? i.name.substring( 0, 30 ) + '...' : i.name;
                            } else {
                                return <span className='italic'>No Name</span>;
                            }  
                        } }
                        filterOption={ ( input, option ) => 
                            option.name.toLowerCase().includes( input.toLowerCase() )
                        }
                    />
                </>
            }
        </div>
    );
};

export default FormTags;
